// LIST_SELL.STB reader. A row (the "sellid" referenced by an NPC's
// tab1/tab2/tab3/specialtab columns, see npcstats.ts's getStoreTabs) holds
// the tab's plain-text display name in column 0 (column 1 is unused) and up
// to 46 items from column 2 onward, each packed as itemType*1000+itemNo
// (0 = empty slot) -- World Server/startup.cpp:2525-2550's LoadSellData().
export interface StoreItem {
    itemType: number;
    itemNo: number;
}

export function getStoreItems(sellId: number): StoreItem[] {
    if (!sellId) {
        return [];
    }
    const table = GDM.getNow("list_sell");
    const row = table.row(sellId);
    const items: StoreItem[] = [];
    for (let col = 2; col < table.columnCount; col++) {
        const packed = Number(row[col]) || 0;
        if (packed === 0) {
            continue;
        }
        items.push({
            itemType: Math.floor(packed / 1000),
            itemNo: packed % 1000,
        });
    }
    return items;
}

export function getStoreTabName(sellId: number): string {
    if (!sellId) {
        return "";
    }
    const table = GDM.getNow("list_sell");
    return table.row(sellId)[0] || "";
}
